import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import styles from './TitleComponent.module.scss';
import { getCurrentVariant, sanitizeType, TitleOverlayWrapper } from 'functions';

const TitleComponent = forwardRef((props, ref) => {
  const { properties, type, animationData, children } = props;
  const TitleTag = 'h2';

  const titleWrapperRef = useRef(null);
  // const titleWrapperRef = useCallback(node =>{
  //   if(node!=null){
  //     console.log(node);
  //     const newStyles = {
  //       top: node?.getBoundingClientRect().top,
  //       left: node?.getBoundingClientRect().left,
  //       width: node?.getBoundingClientRect().width,
  //       height: node?.getBoundingClientRect().height
  //     };
  //     setCurrentOverlayStyle(newStyles);
  //   }
  // }, [])

  return (
    (!!properties?.title || !!properties?.subTitle) && (
      <>
        <TitleOverlayWrapper
          styles={styles}
          titleWrapperRef={type == 'withTitleOverlay' || type?.includes('withTitleOverlay') ? titleWrapperRef : null}
        >
          <div
            data-aos={animationData?.animation}
            data-aos-offset={animationData?.animationOffset}
            data-aos-delay={animationData?.animationDelay}
            data-aos-duration={animationData?.animationDuration}
            data-aos-easing={animationData?.animationEasing}
            className={`${styles.content} ${sanitizeType(type, styles)}`}
            ref={!!ref ? ref : titleWrapperRef}
          >
            {!!properties?.title && <TitleTag className={styles.contentTitle}>{properties.title}</TitleTag>}
            {!!properties?.subTitle && <p className={styles.desc}>{properties.subTitle}</p>}
            {children}
          </div>
        </TitleOverlayWrapper>
      </>
    )
  );
});

export default TitleComponent;
